module.exports = __webpack_public_path__ + "img/google.778e7144.svg";